import * as React from 'react';
import { State } from '~/@types/store';
import connect from '~/store/connect';
import { NotificationWrapper, Notification } from '@ixicare/ui';
import { UserActionNotification } from '~/store/Notifications';

interface UserNotificationsProps {
  notifications: UserActionNotification[];
  removeNotification: (notificationId: string) => void;
  children: React.ReactNode;
}

const UserNotifications: React.FC<UserNotificationsProps> = ({ children, notifications, removeNotification }) => {
  const handleClose = React.useCallback(
    (notificationId) => () => {
      removeNotification(notificationId);
    },
    []
  );
  return (
    <>
      {children}
      <NotificationWrapper>
        {notifications.map((not) => (
          <Notification key={not.id} type={not.notificationType} message={not.message} onClose={handleClose(not.id)} />
        ))}
      </NotificationWrapper>
    </>
  );
};

export default connect((state: State) => ({
  notifications: state.notifications.userActionNotifications,
  removeNotification: state.notifications.removeNotification,
}))(UserNotifications);
